import { BannersProps } from './types';

export const isReceiver = ({ relationship, currentPartnerId }: BannersProps) =>
  relationship.receiver_partner.id === currentPartnerId;
